module.exports = __webpack_public_path__ + "static/media/etron_mkz.08c33cff.pdf";